import NavBar from '../../carga/elements/NavBar';
import TableRoterizacao from '../elements/TableRoterizacao';
export default function Gestao() {
    return <div>
        <NavBar />
        <TableRoterizacao />
    </div>
}